import {
  Filter,
  FilterErrors,
  FilterKey,
  isStandardFilterArrayValue,
  Operator,
  StandardFilterValue,
} from 'search/SearchConstants';

// Keep in sync with benchling.search.interface.filters.annotation_residues_filter.MIN_ANNOTATION_RESIDUES_LENGTH
export const MIN_ANNOTATION_RESIDUES_LENGTH = 3;

const ANNOTATION_RESIDUES_LENGTH_ERROR = `Annotation residues search requires at least ${MIN_ANNOTATION_RESIDUES_LENGTH} characters.`;

function getAnnotationResiduesTextValues(value: StandardFilterValue | undefined): Array<string> {
  if (value == null) {
    return [];
  }
  if (typeof value === 'string') {
    return [value];
  }
  if (isStandardFilterArrayValue(value)) {
    return value.filter((v): v is string => typeof v === 'string');
  }
  return [];
}

export default function validateAnnotationResiduesFilters(filters: Array<Filter>): FilterErrors {
  return filters.map((filter) => {
    if (filter.key !== FilterKey.ANNOTATION_RESIDUES) {
      return null;
    }
    if (filter.operator !== Operator.INCLUDES_TEXT && filter.operator !== Operator.EXCLUDES_TEXT) {
      return null;
    }
    for (const text of getAnnotationResiduesTextValues(filter.value)) {
      if (text.length < MIN_ANNOTATION_RESIDUES_LENGTH) {
        return ANNOTATION_RESIDUES_LENGTH_ERROR;
      }
    }
    return null;
  });
}
